import { render } from "./TopMenu.vue?vue&type=template&id=9d8addce&scoped=true&ts=true"
import script from "./TopMenu.vue?vue&type=script&lang=ts"
export * from "./TopMenu.vue?vue&type=script&lang=ts"

import "./TopMenu.vue?vue&type=style&index=0&id=9d8addce&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8addce"]])

export default __exports__